export default {
  title: "Contact person overview",

  input: {
    title: {
      base: "{{action}} person name",
      action: {
        update: "Update",
        create: "Insert",
      },
    },

    name: {
      label: 'Name',
    },
    firstName: {
      label: "First name",
    },
    lastName: {
      label: "Surname",
    },
    lastNameAffix: {
      label: "Surname affix",
    },
    socialSecurityNumber: {
      label: "SSN",
    }
  }
}
